exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dailystats-1{fill:#faedb1}.dailystats-2,.dailystats-6{fill:#fff}.dailystats-3{fill:#2a4e67}.dailystats-4{fill:#ee7470;strokeLinejoin:round}.dailystats-5,.dailystats-6{stroke:none}\n", ""]);
